<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
    <p [innerHTML]="breakContent()"></p>
</div>
<div class="form-footer">
    <button mat-button class="primary" (click)="close()">
        {{ data.btnText ? data.btnText : 'Close' }}
    </button>
</div>
